import updateDataLayer from '@/utils/gtml';
import { useEffect, useState } from 'react';
export function useVideoDataLayerInteractions(media, caption) {
    const [previousProgress, setPreviousProgress] = useState(0);
    useEffect(() => {
        setPreviousProgress(0);
    }, [media]);
    const updateDataLayerProgress = (progress) => {
        updateDataLayer({
            event: 'videoInteraction',
            video_interaction: 'video_progress',
            video_progress: progress,
            video_title: caption,
        });
    };
    const updateDataLayerAction = (action) => {
        updateDataLayer({
            event: 'videoInteraction',
            video_interaction: action === 'START' ? 'video_start' : 'video_complete',
            video_progress: action === 'START' ? '0%' : '100%',
            video_title: caption,
        });
    };
    const updateProgress = (progress) => {
        if (previousProgress < 0.1 && progress > 0.1) {
            updateDataLayerProgress('10%');
        }
        if (previousProgress < 0.25 && progress > 0.25) {
            updateDataLayerProgress('25%');
        }
        if (previousProgress < 0.5 && progress > 0.5) {
            updateDataLayerProgress('50%');
        }
        if (previousProgress < 0.75 && progress > 0.75) {
            updateDataLayerProgress('75%');
        }
        if (previousProgress > 0.9 && progress < 0.1) {
            updateDataLayerAction('COMPLETE');
        }
        setPreviousProgress(progress);
    };
    return { progress: updateProgress, action: updateDataLayerAction };
}
